export default __webpack_public_path__ + "static/media/rbi.b14c4ccd.png";